import { Reveal, SectionHeader } from "./Reveal";
import { useLang } from "@/i18n";

const P = (n) => `/images/logements/villa/${n}.jpg`;

export default function Piscine() {
  const { t } = useLang();

  return (
    <section
      id="piscine"
      data-testid="piscine-section"
      className="py-24 sm:py-32 px-5 sm:px-10"
    >
      <div className="mx-auto max-w-[1500px]">
        <SectionHeader eyebrow={t.piscine.eyebrow} title={t.piscine.title} />

        <div className="grid lg:grid-cols-2 gap-14 mt-12">
          <div className="space-y-5" data-testid="piscine-text">
            {t.piscine.paras.map((p, i) => (
              <Reveal key={i} delay={0.05 * i}>
                <p className="text-sm sm:text-base text-mist font-light leading-relaxed">
                  {p}
                </p>
              </Reveal>
            ))}

            <Reveal delay={0.3}>
              <div
                className="pt-8 border-t gold-hairline grid grid-cols-2 gap-x-6 gap-y-8"
                data-testid="piscine-stats"
              >
                {t.piscine.stats.map((s, i) => (
                  <div key={i}>
                    <div className="font-display text-3xl text-gold">
                      {s.v}
                    </div>
                    <div className="font-mono text-[0.55rem] uppercase tracking-[0.2em] text-sage mt-2 leading-relaxed">
                      {s.l}
                    </div>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>

          <div className="grid grid-cols-2 gap-4 items-start" data-testid="piscine-photos">
            <Reveal delay={0.1}>
              <div className="col-span-2">
                <img
                  src={P("01-piscine-debordement")}
                  alt="La piscine à débordement de 14 mètres face à la mer des Caraïbes"
                  data-testid="piscine-photo-main"
                  loading="lazy"
                  className="col-span-2 w-full aspect-[16/10] object-cover border gold-hairline"
                />
              </div>
            </Reveal>
            <Reveal delay={0.15}>
              <img
                src={P("02-piscine-palmier")}
                alt="Le coco-palmier au bord de la piscine"
                loading="lazy"
                className="w-full aspect-[4/3] object-cover border gold-hairline"
              />
            </Reveal>
            <Reveal delay={0.2}>
              <img
                src={P("08-piscine-aerienne")}
                alt="La piscine vue du ciel"
                loading="lazy"
                className="w-full aspect-[4/3] object-cover border gold-hairline"
              />
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
